import i18n from 'src/i18n';
export let supportPageConstants = {
  pageHeading: i18n.t('supportPageHeading'),
  versionInfo: "Digital Expert version ",
  faq: {
    faqHeading: i18n.t('faqHeading'),
    helpAskText: i18n.t('helpAskText'),
    questions: [
      {
        ques: "How do I book a course?",
        answer: "You need to register with us using your E-mail ID or social media account first. Upon successful registration, you can enroll for any course. If it is a free online course, you will get immediate access upon enrolment and if it is a paid online course, you will get access upon successful payment.."
      },
      {
        ques: "How do I start a session?",
        answer: "You need to register with us using your E-mail ID or social media account first. Upon successful registration, you can enroll for any course. If it is a free online course, you will get immediate access upon enrolment and if it is a paid online course, you will get access upon successful payment.."
      },
      {
        ques: "How do I get service for my equipment?",
        answer: "You need to register with us using your E-mail ID or social media account first. Upon successful registration, you can enroll for any course. If it is a free online course, you will get immediate access upon enrolment and if it is a paid online course, you will get access upon successful payment.."
      },
      {
        ques: "How do I get service for my equipment?",
        answer: "You need to register with us using your E-mail ID or social media account first. Upon successful registration, you can enroll for any course. If it is a free online course, you will get immediate access upon enrolment and if it is a paid online course, you will get access upon successful payment.."
      },
      {
        ques: "How do I get service for my equipment?",
        answer: "You need to register with us using your E-mail ID or social media account first. Upon successful registration, you can enroll for any course. If it is a free online course, you will get immediate access upon enrolment and if it is a paid online course, you will get access upon successful payment.."
      },
    ],
    showAllText: '+ ' + i18n.t('showAllText'),
  },
  contactSection: {
    contactHeading: i18n.t('contactUs'),
    techSupportContactNumber: [
      {
        numberFor: "For Digital Expert technical support, call",
        number: "1-833-901-0860"
      },
    ],
    contactNumbers: [
      {
        numberFor: "For general service support on your equipment, call",
        number: "1-800-437-1171"
      },
      {
        numberFor: "For the TiP application Answer Line, call",
        number: "1-800-682-5327"
      },
    ],
    requestSection: {
      sendRequestText: "Send us a Digital Expert Support Request",
      requestText: "Request support",
      requestLink: "https://www.gehealthcare.com/products/ultrasound/ultrasound-digital-solutions/digital-expert",
      qrText: "Or, scan this QR code with your mobile device's camera to submit a support inquiry directly from your phone.",
    },
    contactSalesSection: {
      contactSalesText: "Interested in purchasing Digital Expert?",
      contactText: "Contact Sales",
      contactLink: "https://www.gehealthcare.com/products/ultrasound/ultrasound-digital-solutions/digital-expert",
    },
    technicalIssuesSection: {
      technicalIssuesText: "Having technical issues?",
      technicalText: "Contact Technical Support",
      technicalLink: "https://www.gehealthcare.com/products/ultrasound/ultrasound-digital-solutions/digital-expert",
    },
    improveFeedbackSection: {
      helpImproveText: i18n.t('helpImproveText'),
      sendFeedbackLinkText: i18n.t('sendFeedbackLinkText'),
    },
  },
  aboutSection: {
    headingText: i18n.t('aboutHeadingText'),
    privacyText: "Privacy Policy",
    privacyLink: "",
    softwareText: i18n.t('softwareText'),
    softwareButtonText: i18n.t('softwareButtonText'),
    productUpdatesText: "Product Updates",
    productUpdatesLink: "",
    manualButtonText: "Digital Expert User Manual",
    downloadAvailable: "DOWNLOAD_AVAILABLE",
    noDownloadAvailable: "NO_DOWNLOAD_AVAILABLE",
    noDownloadAvailableAccount: "NO_DOWNLOAD_AVAILABLE_ACCOUNT_NOT_FOUND"
  }
};

i18n.on('languageChanged', function () {
  updateTranslations();
});

function updateTranslations() {
  supportPageConstants.pageHeading = i18n.t('supportPageHeading');
  supportPageConstants.faq.faqHeading = i18n.t('faqHeading');
  supportPageConstants.faq.helpAskText = i18n.t('helpAskText');
  supportPageConstants.faq.showAllText = '+ ' + i18n.t('showAllText');
  supportPageConstants.contactSection.contactHeading = i18n.t('contactUs');
  supportPageConstants.contactSection.improveFeedbackSection.helpImproveText = i18n.t('helpImproveText');
  supportPageConstants.contactSection.improveFeedbackSection.sendFeedbackLinkText = i18n.t('sendFeedbackLinkText');
  supportPageConstants.aboutSection.headingText = i18n.t('aboutHeadingText');
  supportPageConstants.aboutSection.softwareText = i18n.t('softwareText');
  supportPageConstants.aboutSection.softwareButtonText = i18n.t('softwareButtonText');
}